import type { IframeHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import type { BlockProps } from '../_block';
import { Block } from '../_block';

export type IframeBlockProps = BlockProps &
  IframeHTMLAttributes<HTMLDivElement> & {
    url: string;
    autoplay: boolean;
    camera: boolean;
    microphone: boolean;
    title?: string;
  };

export const IframeBlock = forwardRef<HTMLDivElement, IframeBlockProps>(
  (
    {
      url,
      autoplay,
      camera,
      microphone,
      width,
      height,
      title,
      ...forwardingProps
    },
    forwardingRef
  ) => {
    const allowParams: Record<string, boolean> = {
      autoplay,
      camera,
      microphone
    };

    const allowAttributes = Object.keys(allowParams)
      .filter((key) => allowParams[key])
      .join(';');

    return (
      <Block {...forwardingProps} ref={forwardingRef}>
        <iframe
          src={url}
          allow={allowAttributes}
          width={width}
          height={height}
          style={{ border: 'none' }}
          title={title || undefined}
          allowFullScreen
        />
      </Block>
    );
  }
);
